module.exports = __webpack_public_path__ + "img/gestao-pessoas.dad9c9b6.jpg";